import * as React from 'react';

export const LittleAuctionIcon = (isHovered: boolean, props?: React.HTMLAttributes<SVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg {...props} height="14" viewBox="0 0 13 14" width="13" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.85 1.986l-.65-.662L6.5 0l3.9 3.972-1.3 1.325-.65-.663-3.9 3.973.65.662-1.3 1.324L0 6.621l1.3-1.324.65.662 3.9-3.973zm0 5.297l1.3-1.324L13 11.917l-1.3 1.324-5.85-5.958zm-5.318 5.72h5.874V14H.532v-.997zm.979-.997h3.916v.997H1.511v-.997z"
      fill={isHovered ? '#CC6E09' : '#FF8400'}
      fillRule="nonzero"
    />
  </svg>
);
